import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    modalData,
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import { Form, Formik } from "formik";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { ACTIONS } from "consts/Actions";

import { RequestServiceActions } from "services/services-mia/RequestServiceActions";

import styles from "styles/pages/ModalActions.module.scss";
import { Box } from "@mui/material";
import { SBMTipoDeDocumentoGet } from "services/services-mia";
import { useMIAService } from "hooks/useMIAService";

export default function DeleteModal({ handleUpdateTable }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingInfo, setIsLoadingInfo] = useState(true);
    const [inRequest, setInRequest] = useState(false);
    const formikRef = useRef(null)
    const getSBMTipoDeDocumento = useMIAService(SBMTipoDeDocumentoGet);

    const row = useRecoilValue(rowSelected);
    const credentials = useRecoilValue(userCredentials);

    const setModalDetails = useSetRecoilState(modalData);
    const setSnackbarInfo = useSetRecoilState(snackbarData);

    const handleGetData = async () => {
        const result = await getSBMTipoDeDocumento({ tipoDeDocumentoId: row.row.id });

        if (result[0]) {
            formikRef.current.setValues({
                id: result[0].sbmTipoDeDocumentoId,
                tipoDeDocumentoCod: result[0].sbmTipoDeDocumentoCod,
                tipoDeDocumentoNombre: result[0].sbmTipoDeDocumentoNombre,
                tipoDeDocumentoDescripcion: result[0].sbmTipoDeDocumentoDescripcion,
                enviaMail: result[0].sbmTipoDeDocumentoMailer === "Y" ? true : false,
                agrupa: result[0].sbmTipoDeDocumentoAgrupa === "Y" ? true : false,
                agrupaCant: result[0].sbmTipoDeDocumentoAgrupaCantidad,
                prioridadFirma: result[0].sbmTipoDeDocumentoPrioridadIntExt,
                PHFirmante: result[0].sbmTipoDeDocumentoPHFirmantes === "Y" ? true : false,
                PHTickets: result[0].sbmTipoDeDocumentoPHTickets === "Y" ? true : false,
            })
        }
        setIsLoadingInfo(false)
    }

    const handleSubmit = async ({ id }) => {
        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);

        const body = {
            service: "SBMTipoDeDocumentoDel",
            params: {
                sbmTipoDeDocumentoId: id,
            },
        };

        let res = await RequestServiceActions(
            body,
            credentials,
            ACTIONS.DELETE,
            setSnackbarInfo
        );
        if (res.status.code === 1) {
            await handleUpdateTable();
            setModalDetails((modalState) => !modalState);
        }
        setInRequest((inRequest) => !inRequest);
        setIsLoading((isLoading) => !isLoading);
    };
    useEffect(() => {
        handleGetData()
    }, [])

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                id: "",
                tipoDeDocumentoCod: "",
                tipoDeDocumentoNombre: "",
                tipoDeDocumentoDescripcion: "",
                enviaMail: true,
                agrupa: false,
                agrupaCant: 0,
                prioridadFirma: "N",
                PHFirmante: true,
                PHTickets: false
            }}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {isLoadingInfo ? <div style={{ margin: "24px" }}><CircularIndeterminate /></div> : <Form className={styles.inputs} noValidate>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Box display={"flex"} flexDirection={"row"} alignItems={"flex-end"} gap={"20px"} justifyContent={"space-between"} width={"100%"}>
                        <FormikTextInput
                            disabled={true}
                            fullWidth={true}
                            name="tipoDeDocumentoCod"
                            labelText={"Código"}
                        />

                        <FormikTextInput
                            disabled={true}
                            fullWidth={true}
                            name="tipoDeDocumentoNombre"
                            labelText={"Nombre"}
                        />
                    </Box>
                    <FormikTextInput
                        disabled={true}
                        fullWidth={true}
                        name="tipoDeDocumentoDescripcion"
                        labelText={"Descripción"}
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Confirmar" }}
                        onSecondaryClick={handleUpdateTable}
                    />

                    {isLoading && <CircularIndeterminate />}
                </div>
            </Form>}
        </Formik>
    );
}
